import React from 'react';
import Zoom from 'react-reveal/Zoom';

import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
//import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: '',
    paragraph: ''
  };

  return (
    <section id="sobre"

      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <Zoom left>
              <div className="tiles-item reveal-from-bottom">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    
                    
                  </div>
                </div>
              </div>
            </Zoom>

            <Zoom bottom>
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Currículo
                    </h4>
                    <p className="m-0 text-sm">
                      <ul style={{ collumns: 2}}>
                        <li>Formado em Odontologia pela UFPR em 1993;</li>
                        <li>Curso de Prótese pela ABO/PR em 1994;</li>
                        <li>Especialização em prótese pela UFPR em 2001</li>
                        <li>Professor substituto na cadeira de Prótese Fixa de 2005 a 2007</li>
                        <li>Uso racional de materiais na Odontologia Estética na ABO/PR em 2009;</li>
                        <li>Curso de atualização em DTM 2022;</li>
                        <li>Especialização em Harmonização Orofacial em 2023;</li>
                      </ul>
                    </p>
                  </div>
                </div>
              </div>
            </Zoom>

            <Zoom right>
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="800">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                   
                   
                   
                  </div>
                </div>
              </div>
            </Zoom>

          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;
